import {
  CONFIRM_PASSWORD_PATTERN,
  MESSAGE_INVALID_DOMAIN,
  MESSAGE_INVALID_EMAIL_LENGTH,
  MESSAGE_INVALID_EMAIL_PATTERN,
  MESSAGE_INVALID_FIRST_NAME_LENGTH,
  MESSAGE_INVALID_LAST_NAME_LENGTH,
  MESSAGE_INVALID_NAME_LENGTH,
  MESSAGE_INVALID_PASSWORD,
  MESSAGE_INVALID_PASSWORD_LENGTH,
  MESSAGE_INVALID_PASSWORD_PATTERN,
  MESSAGE_PASSWORD_CONFIRMPASSWORD_MISMATCH,
} from "../constants/messages";

export const emailValidation = (email) => {
  if (!email.length) {
    return { isValid: false, message: MESSAGE_INVALID_EMAIL_LENGTH };
  }
  let filter =
    /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

  return filter.test(email)
    ? { isValid: true, message: "" }
    : { isValid: false, message: MESSAGE_INVALID_EMAIL_PATTERN };
};

export const passwordValidation = (password) => {
  if (!password.length) {
    return { isValid: false, message: MESSAGE_INVALID_PASSWORD_LENGTH };
  }

  let filter = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,30}$/;
  if (password?.length >= 8) {
    return filter.test(password)
      ? { isValid: true, message: "" }
      : { isValid: false, message: MESSAGE_INVALID_PASSWORD_PATTERN };
  } else {
    return { isValid: false, message: MESSAGE_INVALID_PASSWORD };
  }
};

export const confirmPasswordvalidation = (pass, confPass) => {
  if (!confPass.length) {
    return { isValid: false, message: CONFIRM_PASSWORD_PATTERN };
  }
  if (confPass === pass) {
    return { isValid: true, message: "" };
  } else {
    return {
      isValid: false,
      message: MESSAGE_PASSWORD_CONFIRMPASSWORD_MISMATCH,
    };
  }
};

export const nameValidation = (name) => {
  return name?.length
    ? { isValid: true, message: "" }
    : { isValid: false, message: MESSAGE_INVALID_NAME_LENGTH };
};

export const firstNameValidation = (name) => {
  return name?.length
    ? { isValid: true, message: "" }
    : { isValid: false, message: MESSAGE_INVALID_FIRST_NAME_LENGTH };
};
export const lastNameValidation = (name) => {
  return name?.length
    ? { isValid: true, message: "" }
    : { isValid: false, message: MESSAGE_INVALID_LAST_NAME_LENGTH };
};

export const domainValidation = (domain) => {
  // subdomain regex
  let filter = /^[a-zA-Z0-9][a-zA-Z0-9\-]+[a-zA-Z0-9]$/;

  if (!domain.length) {
    return { isValid: false, message: MESSAGE_INVALID_DOMAIN };
  }

  return filter.test(domain)
    ? { isValid: true, message: "" }
    : { isValid: false, message: MESSAGE_INVALID_DOMAIN };
};
